<template lang="pug">
  div#slider
    v-layout(row wrap)
      v-flex.label(xs6) {{ min }}
      v-flex.label(xs6 text-xs-right) {{ max }}
    vue-slider(
      ref="slider"
      v-model="period"
      :min="min"
      :max="max"
      height="10"
      tooltip-dir="bottom"
      :process-style="processStyle"
      :slider-style="sliderStyle"
      :tooltip-style="tooltipStyle"
      :lazy="lazy"
      class="mb-4")
</template>

<script>
import vueSlider from "vue-slider-component";
import * as _ from "lodash";
import VictimPostalVue from '../../../admin/src/components/Postal/VictimPostal.vue';

export default {
  name: "Slider",
  components: {
    vueSlider
  },
  props: ['victimFilters'],
  data: function() {
    return {
      periodi: [2016, 2018],
      lazy: true,
      processStyle: {
        backgroundColor: "#de7eaf"
      },
      sliderStyle: [
        { backgroundColor: "#c90287" },
        { backgroundColor: "#c90287" }
      ],
      tooltipStyle: [
        {
          backgroundColor: "transparent",
          borderColor: "transparent",
          color: "#747474",
          "font-size": "11px"
        },
        {
          backgroundColor: "transparent",
          borderColor: "transparent",
          color: "#747474",
          "font-size": "11px"
        }
      ]
    };
  },
  computed: {
    min() {
      if (this.victimFilters) {
        return this.$store.state.minVictimYear;
      }
      return this.$store.state.min;
    },
    max() {
      if (this.victimFilters) {
        return this.$store.state.maxVictimYear;
      }
      return this.$store.state.max;
    },
    period: {
      get() {
        if (this.victimFilters) {
          return this.$store.state.filters.victimYears;
        }
        return this.$store.state.filters.period;
      },
      set(value) {
        if (this.victimFilters) {
          this.$store.commit("setVictimYearsFilter", value);
        } else {
          this.$store.commit("setPeriodFilter", value);
        }
      }
    }
  }
};
</script>

<style>
.label {
  font-size: 11px;
  color: #747474;
  font-weight: 900;
  font-family: "Open Sans", sans-serif;
}
</style>
